import { render, staticRenderFns } from "./group_manage.vue?vue&type=template&id=ca542d6a&scoped=true"
import script from "./group_manage.vue?vue&type=script&lang=js"
export * from "./group_manage.vue?vue&type=script&lang=js"
import style0 from "./group_manage.vue?vue&type=style&index=0&id=ca542d6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca542d6a",
  null
  
)

export default component.exports